import { FlexBox, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';
import { LoginPanel } from './parts/login-panel';
interface ILoginProps {
}
const SupportText = styled(FlexBox)`
`;

const StyledStackPanel = styled(StackPanel)`
    overflow-y: auto;
`;

export default function Login(props: ILoginProps) {
    return (
        <StyledStackPanel width="100%" height="calc(100% - 30px)" orientation="vertical" gap="0" alignContent="center" alignment="center">
            <LoginPanel />
            <SupportText><Typography.Large>Contact your <b>AgilePoint Account Manager</b> to request access.</Typography.Large></SupportText>
        </StyledStackPanel>
    );
}
